import React, { useState } from 'react';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import toast from 'react-hot-toast';

import { Sweetener, SweetenerService } from 'us-web-services';
import DisplayService from '../../util/DisplayService';
import PageStyles from '../../styles/PageStyles';

function SweetenersAdd(props: RouteComponentProps) {
  const { history } = props;
  const [label, setLabel] = useState('');
  const [type, setType] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { classes } = PageStyles();

  const addSweetener = async () => {
    if (!label.trim()) {
      toast.error('Label is required');

      return;
    }

    setIsSubmitting(true);

    const sweetenerData = {
      label: label.trim(),
      type: type.trim() || undefined,
      disabled: null,
    } as Sweetener;

    try {
      await SweetenerService.create(sweetenerData);
      toast.success('Sweetener successfully added');
      history.push('/sweeteners');
    } catch (error) {
      const displayedError = DisplayService.getErrorResponse(
        error,
        'There was an error adding the sweetener.',
      );

      toast.error(displayedError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const cancel = () => {
    history.push('/sweeteners');
  };

  const updateLabel = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLabel(event.target.value);
  };

  const updateType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setType(event.target.value);
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && !isSubmitting) {
      addSweetener();
    }
  };

  return (
    <Paper className={classes.paper}>
      <Typography variant='h5' gutterBottom>
        Add Sweetener
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            id='sweetener-label'
            label='Label'
            variant='outlined'
            fullWidth
            required
            value={label}
            onChange={updateLabel}
            onKeyPress={handleKeyPress}
            helperText='The display label for this sweetener (e.g., "Free trial period", "Discounted rates")'
            error={!label.trim() && label.length > 0}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='sweetener-type'
            label='Type'
            variant='outlined'
            fullWidth
            value={type}
            onChange={updateType}
            onKeyPress={handleKeyPress}
            helperText='Optional type identifier for this sweetener'
          />
        </Grid>
      </Grid>
      <div className={classes.buttons} style={{ marginTop: 20 }}>
        <Button
          id='cancel'
          variant='contained'
          color='secondary'
          onClick={cancel}
          disabled={isSubmitting}
          style={{ marginRight: 10 }}
        >
          Cancel
        </Button>
        <Button
          id='add-sweetener-button'
          variant='contained'
          color='primary'
          onClick={addSweetener}
          disabled={isSubmitting || !label.trim()}
        >
          {isSubmitting ? 'Adding...' : 'Add Sweetener'}
        </Button>
      </div>
    </Paper>
  );
}

export default withRouter(SweetenersAdd);
